import React from 'react';

const Pane = (props) =>
{
  return (
    <div>
      {props.children}
    </div>
  );
}

export default Pane;
